import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { EventLayout } from './layouts/EventLayout';
import { AdminLayout } from './layouts/AdminLayout';

import { CheckIn } from './pages/EventMode/CheckIn';
import { WalkIn } from './pages/EventMode/WalkIn';
import { Dashboard } from './pages/EventMode/Dashboard';

import { Guests } from './pages/AdminMode/Guests';
import { Imports } from './pages/AdminMode/Imports';
import { Settings } from './pages/AdminMode/Settings';
import { SystemCheck } from './pages/AdminMode/SystemCheck';

function App() {
  return (
    <StoreProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<EventLayout />}>
            <Route index element={<CheckIn />} />
            <Route path="walk-in" element={<WalkIn />} />
            <Route path="dashboard" element={<Dashboard />} />
          </Route>

          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/guests" replace />} />
            <Route path="guests" element={<Guests />} />
            <Route path="imports" element={<Imports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="system-check" element={<SystemCheck />} />
            <Route path="audiences" element={<div className="p-8 text-center text-gray-500">Post-Event Audiences module coming soon.</div>} />
          </Route>
        </Routes>
      </HashRouter>
    </StoreProvider>
  );
}

export default App;